import { render, staticRenderFns } from "./ProjectTree.vue?vue&type=template&id=6fdb1b6b&"
import script from "./ProjectTree.vue?vue&type=script&lang=js&"
export * from "./ProjectTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports